// extracted by mini-css-extract-plugin
export default {"left":"MainBreak_left__k7A8K","para":"MainBreak_para__IbvkW","right":"MainBreak_right__+x8gZ","container":"MainBreak_container__lsHQb"};